import { motion, AnimatePresence } from 'framer-motion'
import useStore from '../store/useStore'
import Toast from './Toast'

function ToastContainer() {
  const { toasts = [], removeToast } = useStore()

  // Don't render if no toasts
  if (!toasts || toasts.length === 0) {
    return null
  }

  return (
    <div className="fixed top-20 right-4 z-60 space-y-2">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.3 }}
          >
            <Toast 
              message={toast.message}
              points={toast.points}
              type={toast.type}
              isVisible={true}
              onHide={() => removeToast(toast.id)}
            />
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  )
}

export default ToastContainer